import React from 'react';
import PropTypes from 'prop-types';

const IconDiscontinued = ({ width, height }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width={width} height={height}>
        <path
            d="M47.155 35.803L29.537 8.169C28.543 6.627 26.847 6 25 6s-3.543.627-4.536 2.17L2.845 35.802a5.285 5.285 0 0 0-.182 5.43A5.39 5.39 0 0 0 7.382 44h35.236a5.39 5.39 0 0 0 4.72-2.768 5.285 5.285 0 0 0-.183-5.43zM25 39.398c-1.62 0-2.933-1.3-2.933-2.905 0-1.605 1.313-2.906 2.933-2.906 1.62 0 2.933 1.301 2.933 2.906 0 1.604-1.313 2.905-2.933 2.905zm2.621-10.554c-.213 1.418-1.546 2.397-2.978 2.186a2.614 2.614 0 0 1-2.202-2.153l-.35-11.291a2.941 2.941 0 0 1 2.94-3.033 2.941 2.941 0 0 1 2.94 3.033l-.35 11.258z"
            fill="#B10043"
            fillRule="nonzero"
        />
    </svg>
);

IconDiscontinued.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
};

IconDiscontinued.defaultProps = {
    width: 15,
    height: 15,
};

export default IconDiscontinued;
